<template>
    <Breadcrumbs main="Blog" title="Blog Single" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="blog-single">
                    <blogDetails />
                    <commentBox />
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const blogDetails = defineAsyncComponent(() => import("@/components/theme/blog/single/blogDetails.vue"))
const commentBox = defineAsyncComponent(() => import("@/components/theme/blog/single/commentBox.vue"))
</script>